<template>
  <b-input-group>
    <input type="text" v-model="groupParameter.value" class="form-control" :placeholder="groupParameter.placeholder">
    <ButtonGroup v-if="groupParameter.action.group.length > 0" class="input-group-append" @change="change" :action="groupParameter.action"></ButtonGroup>
    <b-input-group-append>
      <b-button @click="search" variant="info">
        <i class="fa fa-search"></i>
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
  export default {
    name: 'components-cpmmon-screen-search',
    props: {
      groupParameter: {
        type: Object,
        default: {
          value: '',
          placeholder: '请输入',
          action: {}
        }
      }
    },
    data () {
      return {
        butGrounp: ''
      }
    },
    methods: {
      change (d) {
        this.butGrounp = d
      },
      search () {
        this.$emit('searchAsk', this.groupParameter.value, this.butGrounp)
      }
    }
  }
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/screen-search/screen-search.vue